export default __webpack_public_path__ + "static/media/Graph Visual.60d32015.svg";